import { useEffect, useRef, useState } from 'react';
import Peer from 'peerjs';
import Draggable from 'react-draggable'; 
import VideocamIcon from '@mui/icons-material/Videocam';
import VideocamOffIcon from '@mui/icons-material/VideocamOff';
import MicIcon from '@mui/icons-material/Mic';
import MicOffIcon from '@mui/icons-material/MicOff';
import Stack from '@mui/material/Stack';
import useAuth from '../../hooks/Auth/useAuth';
import CallingTone from "../../assets/toneRing.mp3";
import IncomingRingtone from "../../assets/incomingRingtone.mp3";
// sockets handled via context voiceSocketsApi
import renderCustomModalFunction, { triggerModalOverlayClick } from '../customModal/modalWrapper/renderCustomModalFunction';

import './voice.css';



function VoiceCall() {
  // sockets and availability management handled via AuthProvider + voiceSocketsApi
  let { auth, voiceSocketsApi } = useAuth();
  const nodeRef = useRef(null);
  const localStreamRef = useRef(null);
  const [peerId, setPeerId] = useState('');
  const remoteVideoRef = useRef(null);
  const[callConnections,setCallConnections] = useState(null);
  const currentUserVideoRef = useRef(null);
  const peerInstance = useRef(null);
  const voiceCallSocketRef = useRef(null);
  const [onCall,setonCall] = useState(false)
  const [userData,setUserData] = useState(null)
  const [tryCall,setTryCall] = useState(false);
  const [videoOn,setVideoOn]=useState(true);
  const [micOn,setMicOn]=useState(true);
  const [focousOnUserVideo,setFocousOnVideo]=useState(true);
  const [videoContainerSmall,setVideoContainerSmall]=useState(true);
  // removed legacy per-site sockets state (managed centrally in AuthProvider)
  const [shouldCloseCall, setShouldCloseCall] = useState(false);
  const [isAdminClickRejectVoiceCall,setIsAdminClickRejectVoiceCall]=useState(false);
  const [localStream,setLocalStream] = useState({value: null, isUserCall: true});
  const currentCall = useRef(null);
  const [waitingForReconnect, setWaitingForReconnect] = useState(false);
  const isAdminClickRejectVoiceCallRef = useRef(false);
  const closeStreamRef = useRef(true);
  const reconnectingStateTextRef = useRef(false);
  const remoteAudioRef = useRef(null);
  const connectedUserArrayRef = useRef(null);
  const pendingGetAdminServiceCallsRef = useRef([]);

  useEffect(() => {
    const handleBeforeUnload = (e) => {
      console.log("USER REFRESHING WINDOW");
      //closeVoiceFromAdmin();
      e.returnValue = "";
    }

    window.addEventListener('beforeunload', handleBeforeUnload);

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, []);

  const stopTracks = (videoRef) => {
    if (videoRef.current && videoRef.current.srcObject) {
      releaseTracks(videoRef.current.srcObject)
      videoRef.current.srcObject = null;
    }
  };

  const releaseTracks =(stream)=>{
    if(stream && closeStreamRef.current){
      const tracks = stream.getTracks();
      tracks.forEach(function(track) {
        if (track.readyState === 'live') {
          track.stop();
        }
      });
    }
  }

  const closeVoice =(isCancelActive= isAdminClickRejectVoiceCall,p_callConnections= callConnections ,p_tryCall=tryCall,p_localStream = localStream.value )=>{
    console.log("close voice ",isCancelActive, closeStreamRef.current)

    //close peer connection
    p_callConnections && p_callConnections.close();
    console.log(p_callConnections, p_localStream, p_tryCall);
    // release media connection

    if(p_localStream){
      releaseTracks(p_localStream)
      console.log("localStream released");
    }else{
      stopTracks(currentUserVideoRef);
    }
    console.log("after p_localStream", p_localStream, currentUserVideoRef.current, remoteVideoRef.current);
    stopTracks(remoteVideoRef);


    // send end call to user 
    if(isCancelActive){
      closeVoiceFromAdmin();
    }

    if(p_tryCall){
      cancelAdminTryCall();
      setTryCall(false);
    }
    triggerModalOverlayClick("incomingVoiceCall");


    setonCall(false);
    console.log("set on call false");
    setCallConnections(null);

    // emit to all servers(sites list) that admin is available 
    sendAdminAvalability(true);
    resetVideoContainerStates();
    console.log("End of VoiceCall");
  }

  const resetVideoContainerStates =()=>{
    setVideoContainerSmall(true);
    setFocousOnVideo(true);
  }

  const closeVoiceFromAdmin = () => {
    if (voiceCallSocketRef.current && voiceCallSocketRef.current.userData) {
        const targetSocket = voiceCallSocketRef.current.userData.socket;
        if (targetSocket) {
            voiceCallSocketRef.current.socket.emit('closeVoiceFromAdmin', targetSocket);
            console.log("Emitted closeVoiceFromAdmin for:", targetSocket);
        } else {
            console.error("Target socket is missing in userData:", voiceCallSocketRef.current.userData);
        }
    } else {
        console.error("voiceCallSocketRef is not properly initialized:", voiceCallSocketRef.current);
    }
};


  const cancelAdminTryCall = ()=>{
    if( voiceCallSocketRef.current){
      console.log('cancelling',voiceCallSocketRef.current);
      voiceCallSocketRef.current.socket.emit('cancelVoiceFromAdmin',voiceCallSocketRef.current.userData?.user_id);
    }
  }

  const adminNotAvailable = ()=>{
    if( voiceCallSocketRef.current){
      voiceCallSocketRef.current.socket.emit('adminNotAvailable',voiceCallSocketRef.current.userData.socket)
    }
  }

  const adminRecivedTheIncomingVoiceCall =()=>{
    if( voiceCallSocketRef.current){
      voiceCallSocketRef.current.socket.emit('adminRecivedTheIncomingVoiceCall',auth.userId);
    }
  }

  const establishAdminCall = () => {
    if (!remoteAudioRef.current) {
      remoteAudioRef.current = document.createElement('audio');
      remoteAudioRef.current.autoplay = true;
      remoteAudioRef.current.playsInline = true;
      document.body.appendChild(remoteAudioRef.current);
      
    }

    connectedUserArrayRef.current.forEach((user)=>{
      //Calling 
      const id = user.peerId;
      const call = peerInstance.current.call(id, localStreamRef.current);
      
      call.on('stream', function(remoteStream) {
        closeStreamRef.current = false;
        updateRemotePeerID(id);
        localStorage.setItem("remotePeerID", id);
        remoteAudioRef.current.srcObject = remoteStream;
        remoteAudioRef.current.play();


        reconnectingStateTextRef.current = false;
        call.peerConnection.oniceconnectionstatechange = function () {
          console.log("ICE connection state changed:", call.peerConnection.iceConnectionState, remoteStream, call);

          if(call.peerConnection.iceConnectionState === 'disconnected')
          {
            reconnectingStateTextRef.current = true;
          }
        };

        setonCall(true);
        console.log("set on call true");
        setCallConnections(call);
        setTryCall(false); 
        // update server that admin is calling back to passenger
        
        voiceCallSocketRef.current.userData.socket= user.socket;

        setUserData((prev) => ({
          ...prev,
          socket: user.socket,
        }));

        currentUserVideoRef.current.srcObject = localStreamRef.current;
        
      })
    })
  }

  const establishUserCall = () => {
    console.log("Manager audio stream acquired:", localStreamRef.current);

    closeStreamRef.current = false;

    adminRecivedTheIncomingVoiceCall();
    
    currentCall.current.answer(localStreamRef.current);
    currentUserVideoRef.current.srcObject = localStreamRef.current;


    if (!remoteAudioRef.current) {
      remoteAudioRef.current = document.createElement('audio');
      remoteAudioRef.current.autoplay = true;
      remoteAudioRef.current.playsInline = true;
      document.body.appendChild(remoteAudioRef.current);
      
    }

    setonCall(true);
    console.log("answered call:", currentCall.current);

    localStorage.setItem("remotePeerID", currentCall.current.peer);

    currentCall.current.on('error', ()=>{
      console.log("close from call.on('error' ");
      setShouldCloseCall(true);
    })

    currentCall.current.on('stream', function(remoteStream) {
      console.log('Remote stream received:', remoteStream);
      updateRemotePeerID(currentCall.current.peer);

      remoteAudioRef.current.srcObject = remoteStream;
      
      console.log("current remote stream:", remoteAudioRef.current.srcObject);

      reconnectingStateTextRef.current = false;
      currentCall.current.peerConnection.oniceconnectionstatechange = function () {
        console.log("ICE connection state changed:", currentCall.current.peerConnection.iceConnectionState, remoteStream, currentCall.current);

        if(currentCall.current.peerConnection.iceConnectionState === 'disconnected')
        {
          reconnectingStateTextRef.current = true;
        }
      };

      if(isAdminClickRejectVoiceCallRef.current)
      {
        setShouldCloseCall(true);
      }
      else
      {
        remoteAudioRef.current.play();
      }

    });


    currentCall.current.on('close', ()=>{
      console.log("disconnect");
    })
  }

  const conifrmVoiceCall = (call)=>{
    console.log("Manager answering the call...");
    currentCall.current = call;
    
    if(!localStreamRef.current)
    {
      console.log("new user media obtained");
      navigator.mediaDevices.getUserMedia({  audio: true })
      .then((stream) => {
        
        setLocalStream(prev => ({...prev, value: stream, isUserCall: true}));

      })
      .catch((err) => {
        console.log("cant answer " + err);
        adminNotAvailable();
      });
    }
    else
    {
      console.log("old user media obtained");
      establishUserCall();
    }
    
  }

  const isAdminOnCall = ()=>{
    const adminOnCall = localStreamRef.current !== null;
    console.log('admin on call:',localStreamRef.current, localStreamRef.current != null, localStreamRef.current !== null)
    return adminOnCall; 
  }

  const incomingVoiceCall =(call)=>{

    setCallConnections(call);
    sendAdminAvalability(false);

    let userName = voiceCallSocketRef && voiceCallSocketRef.current && voiceCallSocketRef.current.userData &&voiceCallSocketRef.current.userData.name ? voiceCallSocketRef.current.userData.name :'Client';
    let siteName =voiceCallSocketRef && voiceCallSocketRef.current && voiceCallSocketRef.current.userData &&voiceCallSocketRef.current.userData.site ? voiceCallSocketRef.current.userData.site :'';

    const titleText = `${userName} is calling`;
    const bodyText = `site: ${siteName}`;

    const onConfirm = ()=>{
      conifrmVoiceCall(call);
    }

    const onCancle = (p_active=true)=>{
      console.log ("admin click cancel " ,p_active);
      setIsAdminClickRejectVoiceCall(p_active);
      // Notify the client that admin is not available
      adminNotAvailable();
      setShouldCloseCall(true);
    };

    const options = {
      title: titleText,
      className :"incomingVoiceCall",
      bodyText: bodyText,
      id:"incomingVoiceCall",
      closeOnOutsideClick:false,
      buttons: [
        {
          text: "Decline",
          class: "dangerButton",
          closeModal: true,
          callback:onCancle,
          icon:'f095',
          value: "cancel"
        },
        {
          text: "Answer call",
          class: "successButton",
          closeModal: true,
          icon :<i class="fa-duotone fa-phone"></i>,
          callback:onConfirm,
          value: "confirm"
        }
      ],
    };

    renderCustomModalFunction(options)
  }

  function handleCloseCall() {
    setIsAdminClickRejectVoiceCall(false);
    setShouldCloseCall(true);
  }
  
  function handleGetAdminService(relevant_socket) {
    const admin_name = auth && auth.userName ? auth.userName : "";
    const admin_id = auth && auth.userId ? auth.userId : "";
    const currentRemotePeerID = auth && localStorage.getItem("remotePeerID") ? localStorage.getItem("remotePeerID") : "";
    const reconnect = auth && !waitingForReconnect;
    
    console.log("handleGetAdminService called; peerId=", peerId);
    
    if (peerId) {
      // peerId is ready, emit immediately
      console.log("emitting serviceAdminSocket", [peerId, admin_name, admin_id, currentRemotePeerID, reconnect]);
      relevant_socket.emit('serviceAdminSocket', [peerId, admin_name, admin_id, currentRemotePeerID, reconnect]);
    } else {
      // peerId not ready yet, queue this call
      console.log("peerId not available yet - queuing getAdminService call");
      pendingGetAdminServiceCallsRef.current.push({
        socket: relevant_socket,
        admin_name,
        admin_id,
        currentRemotePeerID,
        reconnect
      });
    }
  }

  // Helper function to process queued getAdminService calls
  const processQueuedGetAdminServiceCalls = () => {
    if (!peerId || pendingGetAdminServiceCallsRef.current.length === 0) return;
    
    console.log(`Processing ${pendingGetAdminServiceCallsRef.current.length} queued getAdminService calls`);
    
    const queuedCalls = [...pendingGetAdminServiceCallsRef.current];
    pendingGetAdminServiceCallsRef.current = []; // Clear the queue
    
    queuedCalls.forEach(({ socket, admin_name, admin_id, currentRemotePeerID, reconnect }) => {
      console.log("emitting queued serviceAdminSocket", [peerId, admin_name, admin_id, currentRemotePeerID, reconnect]);
      socket.emit('serviceAdminSocket', [peerId, admin_name, admin_id, currentRemotePeerID, reconnect]);
    });
  };
  
  function handleCallUserDetails(p_user_data, p_site_name, relevant_socket) {
    // const isAdminOnCallResponse = isAdminOnCall();
    // if (isAdminOnCallResponse) return;

    // Update user data with site information
    p_user_data.site = p_site_name;
    setUserData(p_user_data);

    voiceCallSocketRef.current = {
        socket: relevant_socket,
        userData: { ...p_user_data }, // Ensure userData is fully populated
    };

    console.log("Updated voiceCallSocketRef on handleCallUserDetails:", voiceCallSocketRef.current);
  }

  
  function handleUserCancelVoiceCall(userDetails) {
    const isAdminOnCallResponse =  isAdminOnCall();
    if(!isAdminOnCallResponse) {
     //only if admin not alive with user we'll trigger this event
     console.log("User cancelled voice call, closing modal");
     triggerModalOverlayClick("incomingVoiceCall"); // Close the modal immediately
     setShouldCloseCall(true);
    }
  }
  
  function handleAnotherAdminHandleTheVoiceCall() {
    const isAdminOnCallResponse =  isAdminOnCall();
    if(!isAdminOnCallResponse) {
      //only if admin not alive with user we'll trigger this event
      console.log("Another admin handle the voice call , so remove incoming voice call");
      triggerModalOverlayClick("incomingVoiceCall"); // Close the modal immediately
      setShouldCloseCall(true);
    }
  }
  
  function handlePeerUnavailable() {
    console.log("Peer unavailable");
  }
  
  function handleGetUserDetails(connectedUserArray,site_name,relevant_socket) {

    if (connectedUserArray && !localStorage.getItem("remotePeerID")) {
      console.log(new Date().toISOString());
      console.log("-==-=-=-=-=-=-=-=-=-=-=-", connectedUserArray, "=--=-=-=-=-=-=-=-=-=-=-=-=-");
      setTryCall(true);
      prepareAdminCall(connectedUserArray,site_name ,relevant_socket);
    }
  }
  
  function handleDisconnect() {
    console.log('disConnect');
  }
  
  function handleUserDisconnected() {
    setShouldCloseCall(true);
  }
  
  // send to all servers sites the admin availability - true if available for call and false if unavailable 
  const sendAdminAvalability = (p_isAvailable) => {
    voiceSocketsApi?.sendAdminAvailability(p_isAvailable);
  }

  const updateRemotePeerID = (remotePeerID) => {
    voiceSocketsApi?.updateRemotePeerID(remotePeerID);
  }

  const controlUserVideo = () => {
    if (currentUserVideoRef.current && currentUserVideoRef.current.srcObject) {
        const videoTrack = currentUserVideoRef.current.srcObject.getTracks().find(track => track.kind === 'video');
        if (videoTrack) {
            videoTrack.enabled = !videoOn;
            setVideoOn(!videoOn);
        }
    }
  }

  const controlUserMic = () => {
    if (currentUserVideoRef.current && currentUserVideoRef.current.srcObject) {
        const audioTrack = currentUserVideoRef.current.srcObject.getTracks().find(track => track.kind === 'audio');
        if (audioTrack) {
            audioTrack.enabled = !micOn;
            setMicOn(!micOn);
        }
    }
  }

  const prepareAdminCall =  (connectedUserArray,p_site_name,p_relevant_socket) => {

    if(peerInstance.current && connectedUserArray.length > 0){

        const userDetailsCurrent ={
           name:connectedUserArray[0].userName,
           site:p_site_name,
           user_id:connectedUserArray[0].user_id
        };


        setUserData(userDetailsCurrent);

        voiceCallSocketRef.current = {
          socket:p_relevant_socket,
          userData:userDetailsCurrent
        };
        

        const adminData={
          socket:p_relevant_socket.id,
          name: auth?.userName
        }


        p_relevant_socket.emit("adminCallToUser",{user:connectedUserArray[0].user_id,admin:adminData});
        
        connectedUserArrayRef.current = connectedUserArray;
        if (!localStreamRef.current)
        {
          console.log("new user media obtained");
          navigator.mediaDevices.getUserMedia({  audio: true })
          .then((stream) => {
            
            setLocalStream(prev => ({...prev, value: stream, isUserCall: false}));

          })
        }
        else
        {
          console.log("Old user media obtained");
          establishAdminCall();

        }


    }else{
      // not succeeded
      setTryCall(false);
      return ;
    }
  }

  // Register voice socket callbacks via voiceSocketsApi
  useEffect(()=>{
    if(!voiceSocketsApi) return;
    voiceSocketsApi.registerCallbacks({
      onCloseCall: handleCloseCall,
      onGetAdminService: (siteName, socket)=>{ handleGetAdminService(socket); },
      onCallUserDetails: (data, siteName, socket)=> handleCallUserDetails(data, siteName, socket),
      onUserCancelVoiceCall: handleUserCancelVoiceCall,
      onAnotherAdminHandleTheVoiceCall: handleAnotherAdminHandleTheVoiceCall,
      onPeerUnavailable: handlePeerUnavailable,
      onGetUserDetails: (arr, siteName, socket)=> handleGetUserDetails(arr, siteName, socket),
      onDisconnect: (siteName)=> handleDisconnect(),
      onUserDisconnected: handleUserDisconnected,
    });
    

  },[voiceSocketsApi, peerId]);

  // sitesSockectsConnection now maintained in AuthProvider via onSocketsUpdate

  //PEER JS CONFIGURATION
  useEffect(() => {
    
    const iceConfiguration = {
      host: "peer.carteav.com",
      path: "/",
      debug: 3,
      secure: true, // Keep secure true for HTTPS
      port: 443, // Standard port for HTTPS
      config: {
        iceServers: [
          {
            "urls": "turn:peer.carteav.com:3478",
            "username": "carteav",
            "credential": "Carteav26"
          },
          {
            urls: 'stun:peer.carteav.com:3478'
          },
          {
            urls: 'stun:stun.l.google.com:19302'
          },
        ]
      }
    }
    
    const conn = new Peer(localStorage.getItem("peerID"), iceConfiguration);
    conn.on('data', (data) => {
      console.log("Data received!", data);
    });
    conn.on('connection', function(conn) {
      console.log("connection")
    });

  conn.on('open', (id) => {
      console.log("Manager: Peer connection established with ID:", id);
      if (localStorage.getItem("peerID") === null)
        {
          localStorage.setItem("peerID", id);
        }
      

      const remotePeerID = localStorage.getItem("remotePeerID");
      if (remotePeerID)
      {
        console.log("Reconnecting to prev remote", remotePeerID);
        setWaitingForReconnect(true);
        //setTryCall(true);
      }

      setPeerId(id);
      // update peer meta for sockets (admin identity & peer)
      voiceSocketsApi?.setPeerMeta({
        peerId: id,
        adminName: auth?.userName || '',
        adminId: auth?.userId || '',
        remotePeerID: remotePeerID || '',
        reconnect: !waitingForReconnect,
      });

      // Process any queued getAdminService calls now that peerId is available
      processQueuedGetAdminServiceCalls();


      
        
    });

      // incoming call 
      conn.on('call',(call) => {
      console.log("received a call:", call);
      console.log("current ongoing call:", currentCall.current, localStorage.getItem('remotePeerID'));
      if (currentCall.current || localStorage.getItem('remotePeerID') === call.peer)
      {
        if (currentCall.current)
        {
          currentCall.current.close();
        }
        setCallConnections(call);
        console.log("Checking localStream", localStreamRef.current);
        if (localStreamRef.current)
        {
          releaseTracks(localStreamRef.current);
        }

        conifrmVoiceCall(call);
      }
      
      const isAdminOnCallResponse =  isAdminOnCall();
      //should be apeared pop up when admin is calling
        if(!localStorage.getItem("remotePeerID") && !isAdminOnCallResponse)
          incomingVoiceCall(call);
        
      })

      conn.on('error', (error) => {

        console.log('Error connecting:', error.type);

        if (error.type === "network" && conn.disconnected) {
          console.log("Client: Peer is disconnected, attempting to reconnect...");
            conn.reconnect();
        } else if(error.type === "unavailable-id")
        {
          console.log("id was taken, reconnecting with new peer");
          // Current peer id is probably taken, setting new peer id and refreshing the page, updating current call if needed
          conn.destroy();
          localStorage.removeItem('peerID');
          window.location.reload(true);
        }
        else {
            console.warn("Client: Peer is not in a disconnected state, cannot reconnect.");
        }
      });
      conn.on('disconnected', function() {
        console.log("Admin: Peer connection disconnected");
        conn.reconnect(); // Peer.js built-in reconnect
     });

    conn.on('close', () => {
      console.log('close peer')
    });
   
    peerInstance.current = conn;

    peerInstance.current.on('iceConnectionStateChange', (state) => {
      console.log('ICE Connection State:', state);
    });

    return () => {
      if (peerInstance.current) {
        peerInstance.current.disconnect();
      }
      
    };
  
  }, [])

  // // validate the visibility of vide container
  // useEffect(() => {
  //   if (!waitingForReconnect && localStorage.getItem('remotePeerID')) {
  //     // voiceSocketsApi?.emitServiceAdminSocketAll();
  //   }
  // }, [waitingForReconnect, voiceSocketsApi])

  useEffect(() =>{
    if(localStream.value)
    {
      localStreamRef.current = localStream.value;
      console.log("LOCAL STREAM IS CHANGED", localStream.value);

      if (localStream.isUserCall)
      {
        console.log("establishing user call");
        establishUserCall();
      }
      else
      {
        console.log("establishing admin call");
        establishAdminCall();
      }
    }
  }, [localStream])
  useEffect(()=>{
    const videoContainer = document.getElementById('video-container')
    if(onCall || tryCall || waitingForReconnect){
      videoContainer.style.visibility="visible"
      videoContainer.style.color="white"
    }else{
      videoContainer.style.visibility="hidden"
    }
  },[onCall,tryCall, waitingForReconnect ])

  // Process queued getAdminService calls when peerId becomes available
  useEffect(() => {
    if (peerId) {
      processQueuedGetAdminServiceCalls();
    }
  }, [peerId]);

  useEffect(() => {
    isAdminClickRejectVoiceCallRef.current = isAdminClickRejectVoiceCall;
    if (shouldCloseCall) {
      closeStreamRef.current = true;
      if(remoteAudioRef.current)
      {
        remoteAudioRef.current.pause();
        remoteAudioRef.current.srcObject = null;
        console.log("current remote stream:", remoteAudioRef.current.srcObject);
      }
      console.log("=================================== CURRENTLY IN SHOULD CLOSE VOICE ===========================================")

      closeVoice(isAdminClickRejectVoiceCall,callConnections,tryCall,localStream.value);
      setShouldCloseCall(false);
      setIsAdminClickRejectVoiceCall(false);
      currentCall.current = null;
      localStreamRef.current = null;

      if(localStorage.getItem('remotePeerID'))
      {
        console.log("removing remotePeerID");
        localStorage.removeItem('remotePeerID');
      }
  updateRemotePeerID("");

      setLocalStream(prev => ({...prev, value: null, isUserCall: true}));
      console.log("reset isUserCall");
      localStreamRef.current = null;
    }
  }, [shouldCloseCall,callConnections,tryCall,onCall,isAdminClickRejectVoiceCall,localStream]);

  const playIcomingRingtone = callConnections && !onCall && !tryCall;

  return (
    <div  style={{zIndex:'9999999',position:'fixed',visibility:onCall || tryCall || waitingForReconnect ?'visible':'hidden'}}>
      {playIcomingRingtone && IncomingRingtone && <audio src={IncomingRingtone}  autoPlay />} 
      <Draggable
        nodeRef={nodeRef}
        defaultPosition={{ x:  0, y: window.innerHeight-225 }}
        bounds={{left:0 , right:window.innerWidth-458,bottom:window.innerHeight-225,top:0 }}
      >
        <div
          ref={nodeRef}
          className='video-container'
          id="video-container"
          style={{
            height:videoContainerSmall ?"120px":'400px'
          }}
          >
           
            <div>
              <div>
                {
                  tryCall && !onCall ?
                  <>
                    <div className='videoContainer_userName' style={{left:5}}>Calling to {userData?.name ? userData.name :'Client'}</div> 
                    <audio src={CallingTone}  autoPlay />
                  </>
                  :
                    <div className='videoContainer_userName'>
                      {reconnectingStateTextRef.current ? "Reconnecting": (userData?.name ? userData.name : 'Client')}
                    </div> 
                }
              </div>
              <div className='videoContainer_site'>Site: {userData?.site ? userData.site :'Client'}</div> 
              <div className="videoContainer_endCallButtons">
                <div 
                  className={waitingForReconnect ? 'videoContainer_reconnectCallButton' : 'videoContainer_reconnectCallButton_disabled'} 
                  onClick={(e) => {
                    if (waitingForReconnect)
                    {
                      e.preventDefault();
                      e.stopPropagation();
                      setWaitingForReconnect(false);
                    }
                    
                  }}
                  onTouchStart={(e) => {
                    if (waitingForReconnect)
                    {
                      e.preventDefault();
                      e.stopPropagation();
                      setWaitingForReconnect(false);
                    }
                  }}
                >Reconnect</div>
                <div 
                  className='videoContainer_endCallButton'
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();

                    if(!waitingForReconnect)
                    {
                      setIsAdminClickRejectVoiceCall(true);
                      setShouldCloseCall(true);
                    }
                    else
                    {
                      setIsAdminClickRejectVoiceCall(true);
                      setWaitingForReconnect(false);
                    }
                    
                  }}
                  onTouchStart={(e) => {
                    e.preventDefault();
                    e.stopPropagation();

                    if(!waitingForReconnect)
                    {
                      setIsAdminClickRejectVoiceCall(true);
                      setShouldCloseCall(true);
                    }
                    else
                    {
                      setIsAdminClickRejectVoiceCall(true);
                      setWaitingForReconnect(false);
                    }
                  }}
                >End Call</div>
              </div>
                <div className='videoContainer_extandButton' onClick={()=>{setVideoContainerSmall(!videoContainerSmall)}} />
              </div>
              <div>
                <div style={{
                  display: 'flex',
                  flexDirection: 'row',
                  visibility:!videoContainerSmall  && onCall  ?"visible":'hidden'
                }}>
                  <div
                  style={{
                      display: 'flex',
                      flexDirection: 'column',
                      position:'absolute',
                      top:focousOnUserVideo  ?'280px' : '74px',
                      right:focousOnUserVideo ?'130px':null,
                      width:'100%',
                      justifyContent: 'center',
                      alignItems: 'center',
                    }}
                  >
                    <div className="videoCall_name_header"> me</div> 
                    <video
                      onClick={()=>{
                        setFocousOnVideo(!focousOnUserVideo)
                      }} 
                      width={focousOnUserVideo  ? '90px':'240px'} 
                      height={focousOnUserVideo ? '75px':'170px'} 
                      style={{
                        marginTop:!focousOnUserVideo  ? '8px':'5px',
                        borderRadius:'8px',
                        position:'relative',
                        bottom:'20px',
                      }} 
                      ref={currentUserVideoRef}
                      autoPlay  
                      muted
                    />
                  </div>
                  <div 
                    style={{
                      display: 'flex',
                      flexDirection: 'column',
                      position:'absolute',
                      top:focousOnUserVideo ?'74px' : '280px',
                      right:focousOnUserVideo ?null:'130px',
                      width:'100%',
                      justifyContent: 'center',
                      alignItems: 'center',
                    }}
                  >
                    <div className="videoCall_name_header">{userData?.name ? userData.name :'Client'}</div> 
                  </div>
                </div>
              
              <Stack sx={{
                  bottom:0,
                  width:'100%',
                  backgroundColor:'var(--black)',
                  display:'flex',
                  height:'115px',
                  flexDirection: 'row',
                  alignItems: 'flex-end',
              }} 
              direction="row" 
              spacing={4}
              >
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent:'center',
                    alignItems: 'center',
                    opacity: 0.8,
                    position: 'relative',
                    bottom:6
                  }}
                >
                  <span
                    style={{
                      color:'white',
                      cursor: 'pointer'
                    }}
                    onClick={(e)=>{
                      e.preventDefault();
                      controlUserVideo()
                    }}
                  >
                    {videoOn ? <VideocamIcon  /> : <VideocamOffIcon   />}
                  </span>
                  <p style={{
                    top:'35px',
                    position: 'absolute',
                    fontSize:'0.6rem',
                    fontWeight:'bolder',
                    textAlign: 'center'
                  }}>
                  {videoOn ? 'Stop ' : 'Unstop '}

                  </p>
                </div>
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent:'center',
                    alignItems: 'center',
                    opacity: 0.8,
                    position: 'relative',
                    bottom:6
                    
                  }}
                >
                  <span
                    style={{
                      color:'white',
                      cursor: 'pointer'
                    }}
                  
                  onTouchStart={(e)=>{
                    e.preventDefault();
                    controlUserMic();
                  }}
                >
                  {micOn ? <MicIcon /> : <MicOffIcon />}

                </span>
                  <p style={{
                    top:'35px',
                    position: 'absolute',
                    fontSize:'0.6rem',
                    fontWeight:'bolder',
                    textAlign: 'center'
                  }}>
                  {micOn ? 'Mute' : 'Unmute'}

                  </p>
                </div>
                </Stack>
                </div>
            </div>
        </Draggable> 
    </div>
  );
}

export default VoiceCall;


